import app from '../../../scripts/app';

app.service('activeDraftService', [
  'apiService', 'adStateService', 'addFormService', 'userService', '$interval', '$log',
  function(apiService, adStateService, addFormService, userService, $interval, $log) {
    const modeEnums = Object.freeze({REMOTE: 1, LOCAL: 2});
    const autoSaveInterval = 10000;
    const successRequest = {
      config: {},
      data: {
        status: 'ok',
        data: null,
      },
      status: 200,
      statusText: 'OK'
    };

    let lastSavedDraft;
    let autoSavePromise;
    let localDraftEnabled = false;
    let draftMode = null;

    this.modeEnums = modeEnums;

    const saveDraft = () => {
      this.saveDraft(addFormService.ad, addFormService.form);
    };

    this.getDraftMode = () => {
      const isByHomeowner = addFormService.ad && addFormService.ad.isByHomeowner;
      const isByCommercialOwner = addFormService.ad && addFormService.ad.isByCommercialOwner;

      return draftMode || (isByHomeowner || isByCommercialOwner ? modeEnums.LOCAL : modeEnums.REMOTE);
    };

    this.setDraftMode = mode => {
      mode = mode === 'auto' ? null : mode;

      if (mode !== null && Object.keys(modeEnums).every(name => mode !== modeEnums[name])) {
        return;
      }

      draftMode = mode;
    };

    const getUserId = () => {
      const userId = userService && userService.user && (userService.user.cianUserId || userService.user.userId);

      return userId || null;
    };

    this.saveDraft = (adv, form, skipCompare = false) => {
      if (adv.id) {
        return;
      }

      const mode = this.getDraftMode(); // тип modeEnums
      const isByHomeowner = adv.isByHomeowner;
      const isByCommercialOwner = adv.isByCommercialOwner;

      adv.phones = adStateService.handlePhones(adv.phones, form);

      const ad = adStateService.cleanAdModel(adv, true);

      const adWithoutFiles = angular.copy(ad);

      if (adWithoutFiles.photos && adWithoutFiles.photos.length) {
        adWithoutFiles.photos = adWithoutFiles.photos.length;
      }

      if (ad && ad.category && (skipCompare || !angular.equals(JSON.stringify(adWithoutFiles), lastSavedDraft))) {
        /*
          isByHomeowner удаляется в методе cleanAdModel по флагу !userCanPublishAdAsHomeownerInCurrentCategory.
          Поскольку userCanPublishAdAsHomeownerInCurrentCategory всегда возвращает false для неавторизированных пользователей,
          сохраняем isByHomeowner вручную для работы с локальным черновиком.
          Также userId для сравнения, восстаноавливать ли черновик для конкретного пользователя
        */
        const adWithHomeowner = {
          ...ad,
          isByHomeowner,
          isByCommercialOwner,
          userId: getUserId(),
        };

        if (mode === modeEnums.LOCAL) {
          try {
            localStorage.setItem('savedDraft', JSON.stringify(adWithHomeowner));
            lastSavedDraft = JSON.stringify(adWithoutFiles);

            return;
          } catch (err) {
            // Если при сохр произошел exception, переключаемся на remote
            localStorage.removeItem('savedDraft');
            this.setDraftMode(modeEnums.REMOTE);
          }
        }
        if (userService.isAuthenticated) {
          apiService.postDraft(ad)
            .then(() => {
              lastSavedDraft = JSON.stringify(adWithoutFiles);
            })
            .catch(err => {
              $log.error('Ошибка localStorage: ', err);
            });
        }
      }
    };

    this.getDraftGuid = () => {
      if (lastSavedDraft) {
        const parsedDraft = JSON.parse(lastSavedDraft);

        return parsedDraft.objectGuid;
      }

      return undefined;
    }

    this.deleteDraft = (guid) => {
      lastSavedDraft = undefined;
      const mode = this.getDraftMode(); // тип modeEnums

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve()
          .then(() => {
            localStorage.removeItem('savedDraft');

            return successRequest;
          });
      }

      return apiService.deleteDraft(guid);
    };

    this.isActiveDraftEnabled = () => {
      const mode = this.getDraftMode();

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve(localDraftEnabled);
      }

      return apiService.getDraftSettings()
        .then((settings) => settings && settings.data && settings.data.isDraftEnabled);
    };

    this.enableActiveDraft = (isActiveDraftMustEnabled = true) => {
      const mode = this.getDraftMode();

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve()
          .then(() => {
            localDraftEnabled = isActiveDraftMustEnabled;

            return successRequest;
          });
      }

      return apiService.postDraftSettings({
        isDraftEnabled: isActiveDraftMustEnabled
      });
    };

    this.getActiveDraft = (guid) => {
      const mode = this.getDraftMode();
      const params = {
        objectGuid: guid,
      };

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve()
          .then(() => {
            return {
              data: JSON.parse(localStorage.getItem('savedDraft')),
              status: 'ok'
            };
          });
      }

      return apiService.getDraft(params).then((response) => response.data);
    };

    // Автосохранение в localStorage, если пользователь не авторизован(только для собственников)
    this.setLocalAutoSave = (isAutosaveMustEnabled = true) => {
      $interval.cancel(autoSavePromise);

      if (isAutosaveMustEnabled) {
        this.setDraftMode(modeEnums.LOCAL);
        this.enableActiveDraft(true);
        // Сохраняем сразу, т.к. в кейсе, если польз. заполнил форму как собственник, переключился на агента и решил,
        // что он снова собственник и закроет страницу, черновик не сохранится и при загрузке страницы будет пустая форма
        saveDraft();
        autoSavePromise = $interval(saveDraft, autoSaveInterval);
      } else {
        this.setDraftMode(modeEnums.LOCAL); // Отключаем состояние activeDraft только для локального сохранения
        this.enableActiveDraft(false);
        this.deleteDraft(addFormService.ad.objectGuid);
        this.setDraftMode('auto');
      }
    };
  },
]);
